import * as React from 'react'
import { useState } from 'react'
import Button from '@mui/material/Button'
import CssBaseline from '@mui/material/CssBaseline'
import TextField from '@mui/material/TextField'
import { Link } from 'react-router-dom'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Container from '@mui/material/Container'
import { useAuth } from '../../../context/AuthContext'
import Logo from '../../../images/logo.png'
import { FormHelperText } from '@mui/material'
import ForgotPassword from './ForgotPassword'

function Copyright(props) {
  return (
    <Typography variant='body2' color='text.secondary' align='center' {...props}>
      {'Copyright © '}
      <Typography variant='body2' component={Link} color='inherit' to={'https://itupconsult.fr/'}>
        {'It UP consult'}
      </Typography>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export default function Login() {
  const [input, setInput] = useState({
    login: '',
    password: ''
  })

  const [error, setError] = useState(null)
  const [openPassword, setOpenPassword] = useState(false)
  const { login } = useAuth()

  const [loading, setLoading] = useState(false)
  const handleSubmitLogin = async (event) => {
    event.preventDefault()
    if (!input.login || !input.password) return
    setLoading(true)
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(input)
      })
      const res = await response.json()
      if (res.data) {
        login(res)
        return
      }
      throw new Error(res.message)
    } catch (err) {
      setError("Erreur d'identifiants")
    } finally {
      setLoading(false)
    }
  }

  const handleInput = (e) => {
    const { name, value } = e.target
    setInput((prev) => ({ ...prev, [name]: value }))
    if (error) setError(null)
  }

  return (
    <Container component='main' maxWidth='xs'>
      <CssBaseline />
      <Box
        sx={{
          marginTop: 15,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <img alt='' src={Logo} style={{ width: '20%', marginBottom: 1 }} />

        <Typography component='h1' variant='h5' sx={{ mt: 1 }}>
          Connexion
        </Typography>
        <Box component='form' onSubmit={handleSubmitLogin} noValidate sx={{ mt: 1 }}>
          <TextField
            margin='normal'
            required
            fullWidth
            id='login'
            label='Email'
            name='login'
            autoComplete='email'
            autoFocus
            value={input.login}
            onChange={handleInput}
            type='email'
          />
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Mot de passe'
            type='password'
            id='password'
            autoComplete='current-password'
            value={input.password}
            onChange={handleInput}
          />

          {error && <FormHelperText error>{error}</FormHelperText>}

          <Button disabled={loading} type='submit' fullWidth variant='contained' sx={{ mt: 3, mb: 2 }}>
            {loading ? 'Connexion...' : 'Connexion'}
          </Button>
          <Grid container>
            <Grid item xs>
              <Typography component={Link} onClick={() => setOpenPassword(true)} variant='body2'>
                {'Mot de passe oublié?'}
              </Typography>
            </Grid>
            <Grid item>
              <Typography component={Link} variant='body2' to={`/createAccount`}>
                {'Pas encore de compte? Inscrivez-vous'}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 1, mb: 1 }} />
      <ForgotPassword open={openPassword} setOpen={setOpenPassword} />
    </Container>
  )
}
